import React from "react";
import { REQUIREMENTS } from "../../data/content";
import { Reveal, SectionHeading } from "../shared/Primitives";
import { DotGrid, Scribble } from "../shared/Decor";

export const Requirements = () => {
  return (
    <section id="requisitos" data-testid="requirements-section" className="relative overflow-hidden bg-linen py-16 sm:py-20 lg:py-28">
      <DotGrid className="absolute top-12 right-10 w-24 text-camel/30 hidden sm:block" />
      <Scribble className="absolute -bottom-6 -left-6 w-40 text-camel/20 hidden lg:block" />
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 relative z-10">
        <div className="max-w-3xl">
          <SectionHeading
            overline="Mudarte es fácil"
            title="¿Cómo rentar?"
            subtitle="Un proceso claro y amigable en 5 pasos. Sin complicaciones."
          />
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {REQUIREMENTS.map((req, i) => (
            <Reveal key={req.step} delay={i * 0.08}>
              <div data-testid={`requirement-${i}`} className="group h-full rounded-2xl bg-white border border-khaki/50 p-7 hover:border-cocoa/50 transition-colors">
                <span className="font-display text-5xl font-semibold text-khaki group-hover:text-cocoa transition-colors">
                  {req.step}
                </span>
                <h3 className="mt-4 text-base font-bold text-espresso">{req.title}</h3>
                <p className="mt-2 text-base font-light text-espresso/55 leading-relaxed">{req.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div data-testid="requirements-notice" className="mt-10 rounded-2xl border-l-4 border-cocoa bg-camel/15 p-6">
            <span className="text-xs font-bold tracking-[0.15em] uppercase text-cocoa">Importante</span>
            <p className="mt-2 text-base font-light text-espresso/75 leading-relaxed">
              La estancia mínima es de 2 meses y se solicita un depósito en garantía equivalente a un mes de
              renta, reembolsable al término del contrato. La documentación se valida antes de la firma.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
